module.exports = __webpack_public_path__ + "ICONO-HR-PU-2.png?2da089ca9055bbdf8aab1987c3d59e5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ICONO-HR-PU-2.png
// module id = 667
// module chunks = 0 2 7 8 9 10